import Vue from 'vue';
import { localize, formatTime } from '@/utilities/dateHelpers';
import FaqList from '@/components/composite/FaqList.vue';
import Button from '@/components/Button.vue';
import Carousel from '@/components/Carousel.vue';
import EmbeddedVideo from '@/components/EmbeddedVideo.vue';
import Notification from '@/components/composite/Notification.vue';
import Hyperlink from '@/components/Hyperlink.vue';
import Icon from '@/components/Icon/index.vue';
import Card, { CardBody, CardImage } from '@/components/composite/Card';
import TOGGLES from '@/toggles';
const WEBINAR_DURATION = 1.5 * 60 * 60 * 1000; // 1.5 hours
export default Vue.extend({
    name: 'WebinarPage',
    filters: {
        localizeWebinarDate: (date) => `${localize(date)}, ${formatTime(date)}-${formatTime(new Date(date.getTime() + WEBINAR_DURATION))} WIB`,
    },
    components: {
        Button,
        Carousel,
        EmbeddedVideo,
        Notification,
        Hyperlink,
        Icon,
        Card,
        CardBody,
        CardImage,
        FaqList,
    },
    metaInfo: {
        title: 'Webinar | Kemdikbudristek',
        meta: [
            {
                vmid: 'description',
                name: 'description',
                content: 'Bergabunglah ke Webinar Akun Pembelajaran untuk mengenali Akun Pembelajaran lebih lanjut!',
            },
        ],
    },
    data: () => ({
        TOGGLES,
    }),
    computed: {
        groupedPlatforms() {
            const chunkSize = 15;
            const result = [];
            for (let i = 0; i < this.$getContent('app.platforms.platforms').length; i += chunkSize) {
                result.push(this.$getContent('app.platforms.platforms').slice(i, i + chunkSize));
            }
            return result;
        },
        webinars() {
            return this.$getContent('app.webinars.webinars').map(({ title, date, url, }) => ({ title, date: new Date(date), url }));
        },
    },
});
